import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'phonenumber'})
export class PhoneNumberPipe implements PipeTransform {

    transform(value: string): string {
        const number = value;

        if (number.length === 4) {
            return `*** *** ${number.substring(1, 4)}`;
        }
        if (number.length < 9) {
            return '***';
        } else {
            return `*** *** ${number.substring(6, 9)}`;
        }
      }
}
